import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { AuditFilterModel } from 'src/app/models/audit/audit-filter.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuditService {

  constructor(private _httpClient: HttpClient) { }

  auditRentalBalance(auditFilterModel: AuditFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.audit.AuditRentalBalance}`, auditFilterModel);
  }

  exportAuditRentalBalance(auditFilterModel: AuditFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.audit.ExportAuditRentalBalance}`, auditFilterModel, {
      responseType: 'blob',
    });
  }
}
